import { SORT_OPTIONS } from "../constants/sortOptions";

const buildLabelMap = options =>
	Object.values(options).reduce((acc, opt) => {
		acc[opt.id] = opt.labelKey;
		return acc;
	}, {});

const DEFAULT_LABEL_MAP = buildLabelMap(SORT_OPTIONS);

export const getSortLabelKey = (sortId, options) => {
	const labelMap = options ? buildLabelMap(options) : DEFAULT_LABEL_MAP;
	return labelMap[sortId] || sortId;
};
